import { styled, Typography } from '@mui/material';

const AdverseMediaTitle = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '13px',
});

export default AdverseMediaTitle;
